export const SUPAGARD_UNIQUE_CODE_REGEX = '^(?:SGW|SWG)[03456][0-9]{5}$';
export const SUPAGARD_LEATHER_UNIQUE_CODE_REGEX =
  '^SL((?!000000)[01][0-9]{5}|200000)$';
